export function handle_drop(state, e) {
    state.isDragging = false;

    const files = e?.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const mockEvent = {
        target: { files }
    };

    handle_file_upload(mockEvent, state);
}


export function handle_file_upload(event, state) {
    const files = Array.from(event?.target?.files || []);
    if (!files.length) return;

    state.fileError = null;

    const MAX_FILES = 10;

    if (files.length + state.upload_files.length > MAX_FILES) {
        state.fileError = `Maximum ${MAX_FILES} files allowed.`;
        return;
    }

    files.forEach(file => {
        state.upload_files.push(file);

        // IMAGE
        if (file.type.startsWith("image/")) {
            const reader = new FileReader();

            reader.onload = (e) => {
                state.previews.push({
                    type: "image",
                    src: e.target.result,
                    name: file.name
                });
            };

            reader.readAsDataURL(file);
        }

        // VIDEO
        else if (file.type.startsWith("video/")) {
            const url = URL.createObjectURL(file);

            state.previews.push({
                type: "video",
                src: url,
                name: file.name
            });
        }

        // FILE
        else {
            state.previews.push({
                type: "file",
                name: file.name,
                extension: file.name.split('.').pop().toLowerCase()
            });
        }
    });

    event.target.value = "";
}

export function get_single_file_from_event(event) {
    return event?.target?.files?.[0] || null;
}

export function clear_file_input(event) {
    if (event?.target) {
        event.target.value = "";
    }
}

export function handle_typed_file_upload(event, { accepted_type, invalid_message }) {
    const file = get_single_file_from_event(event);

    if (!file) {
        return {
            file: null,
            file_name: "",
            error: ""
        };
    }

    if (accepted_type && !file.type.startsWith(accepted_type)) {
        clear_file_input(event);

        return {
            file: null,
            file_name: "",
            error: invalid_message || "Invalid file type."
        };
    }

    return {
        file,
        file_name: file.name,
        error: ""
    };
}

export function handle_audio_upload(event) {
    return handle_typed_file_upload(event, {
        accepted_type: "audio/",
        invalid_message: "Only audio files are allowed."
    });
}


function get_profile_base(profile) {
    return profile?.base_profile?.id;
}

function get_profile_user_id(profile) {
    return profile?.base_profile?.user?.id || profile?.user?.id || profile?.creater?.id || profile?.id;
}

function get_profile_url(profile) {
    if (!profile) return "";
    if (typeof profile !== "object") return `/profile?user_id=${profile}`;

    const base = get_profile_base(profile);
    const user_id = get_profile_user_id(profile);
    const is_business = Boolean(profile?.base_profile?.profile_type === "business");

    return base && is_business ? `/profile?base=${base}` : `/profile?user_id=${user_id}`;
}

export function view_profile(_router, profile) {
    const profile_url = get_profile_url(profile);

    if (profile_url) {
        window.location = profile_url;
    }
}
